import { getQueryString, handleError } from "../apiUtils";
import axios from "../axios";

export async function getMapMarkers() {
  try {
    const resp = await axios.get("/api/mapMarker/?pageSize=100");
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function getMapMarker(mapMarker_id: string) {
  try {
    const resp = await axios.get("/api/mapMarker/" + mapMarker_id);
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function updateMapMarkerVideos(
  mapMarkerId: string,
  videoIds: string[]
) {
  try {
    const params = new URLSearchParams();
    params.append("mapMarkerGUID", mapMarkerId);
    videoIds.forEach((id) => params.append("videoGUIDs", id));

    const resp = await axios.post(
      `/api/mapMarker/SetVideos?${params.toString()}`
    );
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function getMapMarkerDetails(mapMarker_id: string) {
  try {
    const resp = await axios.get(`/api/mapMarker/${mapMarker_id}/details`);
    return resp.data;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function createMapMarker(mapMarker: object) {
  try {
    const resp = await axios.put("/api/mapMarker/create/", mapMarker);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function updateMapMarker(mapMarker: object) {
  try {
    const resp = await axios.post("/api/mapMarker/update/", mapMarker);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}

export async function deleteMapMarker(mapMarker_id: string) {
  try {
    const resp = await axios.delete("/api/mapMarker/delete?id=" + mapMarker_id);
    return resp;
  } catch (error) {
    console.log(error);
    handleError(error);
  }
}
